const Companies = [
  "RWS Holdings",
  "Transperfect",
  "Lionbridge",
  "LanguageLine Solutions",
  "Keyword Studios",
  "Appen",
  "Translate Plus",
  "Acolad",
  "Hogarth Worldwide",
  "Welocalize",
  "CyraCom",
  "STAR Group",
  "Pactera",
  "Translation Bureau",
  "AMN Healthcare",
  "PTSGI",
  "Honyaku Center",
  "Pactera EDGE",
  "Ubiqus",
  "Semantix",
  "BIG Language Solutions",
  "Languagewire",
  "SeptroTec",
  "LOGOS GROUP",
  "KERN",
  "Akorbi",
  "Certified Languages International",
  "Verztec",
  "Sunyu Transphere",
  "Sprakservice Sverige",
  "Rozetta",
  "Translated",
  "Crestec",
  "Global Talk",
  "CSOFT",
  "Apostroph",
  "EC Innovations",
  "ZOO Digital",
  "Transvoice Sweden",
  "Janus Worldwide",
  "Versacom",
  "TRSB",
  "Sichuan Lan-Bridge Communications",
  "Argos",
  "Acclaro",
  "Summa Linguae",
  "CBG Konsult and Information",
  "STransline Gruppe",
  "NLG",
  "Alpha CRC",
  "SKrivanek Group",
  "Straker Translations",
  "GLOBO",
  "LanguageLoop",
  "Systran",
  "t works",
  "Human Science Co",
  "LinguaLinx Language Solutions",
  "Supertext",
  "mt-g",
  "Glodom Language Solutions",
  "itl Institut fur Technische Literatur",
  "TOIN Corporation",
  "AWATERA",
  "Propio Language Services",
  "Wordbank",
  "Lingsoft",
  "BLEND",
  "EVS Translations",
  "kothes",
  "Diction",
  "MasterWord Services",
  "e2f",
  "GlobaLexicon",
  "XTM",
  "TRADUTEC",
  "TranslateMedia",
  "Tilde",
  "Angel Translation",
  "Lingo24",
  "Hansem Global Language Services",
  "Iota Localisation Services",
  "Ingenuiti",
  "Sandberge Translation Partners",
  "Kaleidoscope",
  "Linguaserve",
  "Future Group",
  "Linguitronics",
  "OFILINGUA",
  "Leinhause",
  "1 Stop Asia",
  "Global Lingo",
  "EGO Translating Company",
  "Tolingo",
  "CPSL",
  "Tarjama",
  "Lorgus IT",
  "AVB Language Group",
  "Milengo",
  "Master Translation Services",
  "Tetras",
  "Powerling",
];

export default Companies;
